import React, { forwardRef, memo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { m } from "framer-motion";
import { fadeIn } from "../../../../utils/GlobalAnimations";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "../../../store/slices/languageSlice";
import Utils from "../../../../utils/Utils";
import "../../../../assets/scss/components/_iconwithtext.scss";
import { n } from "../../../../utils/Labels";

const TextWithIcon = forwardRef((props, ref) => {
  const { items, parent } = props;
  const lang = useSelector(selectCurrentLanguage);
  const cl = Utils.isValidJson(parent.className)
    ? JSON.parse(parent.className)
    : parent.className;

  return (
    <section
      ref={ref}
      className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px]"
      style={{ ...cl }}
    >
      <Container>
        <Row className="row-cols-1 row-cols-lg-4 row-cols-sm-2 justify-center gap-y-10">
          {items.map((item, i) => (
            <m.div
              key={item.post_content_id}
              className="col landscape:md:!px-0"
              {...{ ...fadeIn, transition: { delay: i * 0.2 } }}
            >
              <div className="custom-icon-with-text01 text-center">
                <img
                  width=""
                  height=""
                  className="inline-block items-center justify-center mb-[30px]"
                  src={Utils.formatURL(
                    `posts/${item?.post_content_id}/${item?.content?.image_main}?s=md`,
                  )}
                  alt={"featurebox"}
                />
                <div className="feature-box-content">
                  {n(item?.title_lang) && (
                    <h3 className="heading-6 title font-medium text-base font-serif text-darkgray mb-[10px]">
                      {n(item?.title_lang)}
                    </h3>
                  )}
                  {item.content?.description_lang &&
                    item.content?.description_lang[lang] && (
                      <p className="text-base text-center">
                        {item.content?.description_lang[lang]}
                      </p>
                    )}
                </div>
              </div>
            </m.div>
          ))}
        </Row>
      </Container>
    </section>
  );
});

export default memo(TextWithIcon);
